import script from "./expiration_submission_form.vue?vue&type=script&setup=true&lang=js"
export * from "./expiration_submission_form.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__